import React from 'react';
import {WarningIcon} from '@ttx/design-system';
import {ModalWrapper} from './modal-wrapper';

export interface CashFailedModalProps {
  imageSrc?: string;
  trackName?: string;
  artist?: string;
  quantity: number;
  transactionHash: string;
  onModalClose: () => void;
  onViewTransactions: () => void;
  onTryAgain: () => void;
}

export const CashFailedModal: React.FC<CashFailedModalProps> = ({
  imageSrc,
  trackName,
  artist,
  quantity,
  transactionHash,
  onModalClose,
  onViewTransactions,
  onTryAgain,
}: CashFailedModalProps) => {
  return (
    <ModalWrapper
      titleIcon={<WarningIcon />}
      title="Payment error"
      copyPrimary="Your payment could not be verified."
      copyPrimary2="Please try again."
      copySecondary="An error occured."
      imageSrc={imageSrc}
      leftButton={{
        label: 'View transactions',
        handlePress: onViewTransactions,
      }}
      rightButton={{
        label: 'Try again',
        handlePress: onTryAgain,
      }}
      bottomTransactionHash={transactionHash}
      artist={artist}
      trackName={trackName}
      quantity={quantity}
      onModalClose={onModalClose}
    />
  );
};
